"use client";

import dynamic from "next/dynamic";
import type { SitePayload } from "@/lib/types";

const WhatsAppButton = dynamic(
  () => import("@/components/WhatsAppButton").then((m) => m.WhatsAppButton),
  { ssr: true },
);

type Props = {
  site?: Pick<
    SitePayload,
    | "whatsappEnabled"
    | "whatsappNumberEn"
    | "whatsappNumberAr"
    | "whatsappPrefillEn"
    | "whatsappPrefillAr"
  >;
};

export function WhatsAppButtonDynamic({ site }: Props) {
  return <WhatsAppButton site={site} />;
}
